import { isEmpty } from 'lodash-es';
import { h } from './p-06a8959f.js';

function renderSuccessMessage(isValid, isSuccess, successMessage, className) {
    if (isValid && isSuccess && !isEmpty(successMessage)) {
        return h("span", { class: className }, successMessage);
    }
}

export { renderSuccessMessage as r };
